import { cdAxios } from "../../lib/axios";
import { keycloak } from "../../lib/keycloak";
import { DistinctAirportResponseDTO, filtersReportDTO, findAllReportResponseDTO, GeneratePdfRequestDTO, ReportCreareRequestDTO, ReportDTO, ReportUpdateDTO } from "./dto";
import { ReportService } from "./service";


export class ReportServiceImpl implements ReportService {
    public findAllReport(
        filters: filtersReportDTO
    ): Promise<findAllReportResponseDTO> {
        return cdAxios
            .get("/api/", {
                params: {
                    page: filters.page,
                    pageSize: filters.pageSize,
                    sort: filters.sort,
                    sortBy: filters.sortBy,
                    name: filters.name,
                    surname: filters.surname,
                    flightIdent: filters.flightIdent,
                    departureAirport: filters.departureAirport,
                    arrivalAirport: filters.arrivalAirport,
                    fromDate: filters.fromDate
                },
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "GET",
                },
            })
            .then((response) => response.data);
    }

    public findByIdReport(id: string): Promise<ReportDTO> {
        let idByPath = window.location.pathname.split("/")[2]
        let _id = id;

        if (idByPath !== undefined && window.location.pathname === ("/report/" + idByPath)) {
            _id = idByPath
        }
        return cdAxios
            .get(`/api/${_id}`, {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "GET",
                },
            })
            .then((response) => response.data);
    }

    public create(request: ReportCreareRequestDTO): Promise<string> {
        return cdAxios
            .post("/api/", request, {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "POST",
                },
            })
            .then((response) => response.data);
    }

    public delete(id: string): Promise<void> {
        return cdAxios
            .delete(`/api/${id}`, {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "POST",
                },
            })
            .then(() => undefined);
    }

    public updateReport(
        id: string,
        request: ReportUpdateDTO
    ): Promise<void> {
        return cdAxios
            .put("/api/" + id, request, {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "GET",
                },
            })
            .then((response) => response.data);
    }

    public refresh(id: string): Promise<string> {
        return cdAxios.post(
            `/api/refresh/${id}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${keycloak.token}`,
                    Accept: "*/*",
                    "Content-Type": "application/json",
                },
            }
        ).then((response) => response.data);
    }

    public distinctAirports(): Promise<DistinctAirportResponseDTO> {
        return cdAxios
            .get("/api/distinct-airports", {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "GET",
                },
            })
            .then((response) => response.data);
    }

    public generatePdf(request: GeneratePdfRequestDTO): Promise<string> {
        return cdAxios
            .post("/api/", request, {
                headers: {
                    Authorization: "Bearer " + keycloak.token,
                    Accept: "*/*",
                    ContentType: "application/json",
                    "Access-Control-Allow-Headers":
                        "accept, authorization, content-type, x-requested-with",
                    "Access-Control-Allow-Origin": "http://localhost:3000",
                    "Access-Control-Allow-Methods": "POST",
                },
            })
            .then((response) => response.data);
    }
}
